import {InitialPremiumNotReceived as InitialPremiumNotReceivedLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

type InitialPremiumNotReceivedProps = {
  initalPremiumNotReceivedLetter: InitialPremiumNotReceivedLetter;
};

const InitialPremiumNotReceived = (props: InitialPremiumNotReceivedProps) => {
  return (
    <>
      <CardField name="Account Number" value={props.initalPremiumNotReceivedLetter.accountNumber} />
      <CardField name="Agent Name" value={props.initalPremiumNotReceivedLetter.agentName} />
      <CardField name="Agent Number" value={props.initalPremiumNotReceivedLetter.agentNumber} />
      <CardField name="Date" value={toFormattedDateAsUTC(props.initalPremiumNotReceivedLetter.date)} />
      <CardField name="Due Date" value={toFormattedDateAsUTC(props.initalPremiumNotReceivedLetter.dueDate)} />
      <CardField name="Insured Name" value={props.initalPremiumNotReceivedLetter.insuredName} />
      <CardField name="Owner Name" value={props.initalPremiumNotReceivedLetter.ownerName} />
      <CardField name="Owner Address" value={props.initalPremiumNotReceivedLetter.ownerAddress!.fullAddress} />
      <CardField name="Policy Number" value={props.initalPremiumNotReceivedLetter.policyNumber} />
    </>
  );
};

export default InitialPremiumNotReceived;
